export default __webpack_public_path__ + "static/media/signal_3.df885d2c.mp3";